import styled from "styled-components";
import { devices } from "../../globalStyle";
import { Link } from "react-router-dom";

export const StyledLink = styled(Link)`
  user-select: none;
`

export const HeaderContainer = styled.header`
  display: flex;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 1.2rem;
  gap: 2rem;
  border-bottom: 1px solid #ebebeb;
  img{
    height: 1.5rem;
  }
`

export const SearchDiv = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  background-color: #f4f4f4;
  padding: .15rem .8rem;
  height: 2.4rem;
  flex: 1;
  max-width: 100rem;
  border-radius: 4rem;

  @media ${devices.largeDesktop} {

  }
`

export const SearchInput = styled.input`
  display: flex;
  border: 0;
  background-color: #f4f4f4;
  height: 100%;
  width: 100%;

  :focus {
    outline: none;
  }

  @media ${devices.largeDesktop} {
  }
`

export const SearchImg = styled.img`
  width: 1.1rem;
  cursor: pointer;

  @media ${devices.largeDesktop} {

  }
`

export const InfoDiv = styled.div`
  display: flex;
  align-items: center;
  user-select: none;
  gap: .7rem;
  font-size: 0.8rem;
  img{
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 50%;
  }
`

export const MenuWrapper = styled.div`
  position: relative;
`

export const MenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  color: #0090D3;
  transition: background 0.15s;

  &:hover {
    background: #e8f6fc;
  }
`

export const DropdownMenu = styled.ul`
  position: absolute;
  top: calc(100% + 0.4rem);
  right: 0;
  list-style: none;
  padding: 0.35rem 0;
  margin: 0;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebebeb;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  z-index: 1100;
  min-width: 11rem;
`

export const DropdownItem = styled.li<{ $active?: boolean }>`
  padding: 0.75rem 1rem;
  cursor: pointer;
  user-select: none;
  color: #696969;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
  background: ${({ $active }) => ($active ? '#e8f6fc' : 'transparent')};

  &:hover {
    background: #f4f6f8;
  }
`

export const DangerDropdownItem = styled.li`
  padding: 0.75rem 1rem;
  cursor: pointer;
  user-select: none;
  color: #DC2626;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;

  &:hover {
    background: #FEF2F2;
  }

  svg {
    color: #DC2626;
  }
`

export const DropdownDivider = styled.li`
  height: 1px;
  background: #f0f0f0;
  margin: 0.25rem 0;
  list-style: none;
`

export const BellWrapper = styled.div`
  position: relative;
`

export const BellButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  color: #444;
  transition: background 0.15s;
  position: relative;

  &:hover {
    background: #f4f6f8;
  }
`

export const BellBadge = styled.span`
  position: absolute;
  top: 2px;
  right: 2px;
  background: #dc2626;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  border-radius: 50%;
  min-width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  pointer-events: none;
`

export const BellDropdownContainer = styled.div`
  position: absolute;
  top: calc(100% + 0.4rem);
  right: 0;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.13);
  z-index: 1100;
  width: 320px;
  max-height: 420px;
  display: flex;
  flex-direction: column;
`

export const BellDropdownHeader = styled.div`
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 0.5rem;
`

export const BellTab = styled.button<{ $active: boolean }>`
  flex: 1;
  padding: 0.65rem 0.5rem;
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? '600' : '400')};
  color: ${({ $active }) => ($active ? '#0090D3' : '#666')};
  border: none;
  background: transparent;
  cursor: pointer;
  border-bottom: 2px solid ${({ $active }) => ($active ? '#0090D3' : 'transparent')};
  transition: all 0.15s;

  &:hover {
    color: #0090D3;
  }
`

export const BellDropdownBody = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  flex: 1;
`

export const BellNotifItem = styled.li<{ $unread: boolean }>`
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  background: ${({ $unread }) => ($unread ? '#f0f9ff' : 'transparent')};
  transition: background 0.12s;

  &:hover {
    background: #e8f6fc;
  }

  &:last-child {
    border-bottom: none;
  }
`

export const BellNotifAuthor = styled.p`
  font-size: 12px;
  font-weight: 600;
  color: #172b4d;
  margin: 0 0 2px;
`

export const BellNotifComment = styled.p`
  font-size: 12px;
  color: #555;
  margin: 0 0 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const BellNotifTicket = styled.p`
  font-size: 11px;
  color: #0090D3;
  margin: 0;
`

export const BellEmptyState = styled.p`
  text-align: center;
  color: #999;
  font-size: 13px;
  padding: 2rem 1rem;
  margin: 0;
`
